import './header-filter.scss';

/**
 * Homepage header filter — uses aanbod-new REST API and redirects to /aanbod with query params.
 */
( function( $ ) {

	'use strict';

	var formSelector = '.js-headerFilterForm';

	function getForm() {
		return $( formSelector );
	}

	function getRestUrl( $form ) {
		return $form.data( 'rest-url' ) || '';
	}

	function getModelSelect( $form ) {
		return $form.find( '.search-field.model select, #header-filter-model' );
	}

	function getMerkSelect( $form ) {
		return $form.find( '[name="merk"], #header-filter-merk' );
	}

	/**
	 * Build query params for REST / archive redirect (skip empty values and selectie_frontpage).
	 *
	 * @param {jQuery} $form Form element.
	 * @return {Object}
	 */
	function getFilterParams( $form ) {
		var params = {};

		$form.serializeArray().forEach( function( field ) {
			if ( ! field.name || field.value === '' || field.value === '0' ) {
				return;
			}

			if ( 'selectie_frontpage' === field.name ) {
				return;
			}

			if ( field.name.slice( -2 ) === '[]' ) {
				if ( ! params[ field.name ] ) {
					params[ field.name ] = [];
				}
				params[ field.name ].push( field.value );
				return;
			}

			params[ field.name ] = field.value;
		} );

		var frontpageValue = $form.find( 'input[name="selectie_frontpage"]:checked' ).val();
		if ( 'bedrijfswagens' === frontpageValue || 'personenwagens' === frontpageValue ) {
			if ( ! params['type[]'] ) {
				params['type[]'] = [];
			}
			params['type[]'].push( frontpageValue );
		}

		return params;
	}

	/**
	 * @param {jQuery} $form Form element.
	 * @return {string}
	 */
	function buildArchiveUrl( $form ) {
		var archiveUrl = $form.attr( 'action' ) || '';
		var params     = getFilterParams( $form );
		var query      = $.param( params );

		if ( ! query ) {
			return archiveUrl;
		}

		return archiveUrl + ( archiveUrl.indexOf( '?' ) >= 0 ? '&' : '?' ) + query;
	}

	function updateModelFieldState( $form ) {
		var $modelWrapper = $form.find( '.search-field.model' );
		var $merkSelect   = getMerkSelect( $form );
		var $modelSelect  = getModelSelect( $form );

		if ( ! $merkSelect.length || ! $modelSelect.length ) {
			return;
		}

		if ( $modelWrapper.hasClass( '-loading' ) ) {
			return;
		}

		var merkValue = $merkSelect.val();

		if ( merkValue && merkValue !== '' && merkValue !== '0' ) {
			$modelSelect.prop( 'disabled', false );
			if ( $modelWrapper.length ) {
				$modelWrapper.removeClass( '-disabled -hint-visible' );
			}
		} else {
			$modelSelect.prop( 'disabled', true );
			$modelSelect.val( '' ).prop( 'selectedIndex', 0 );
			if ( $modelWrapper.length ) {
				$modelWrapper.addClass( '-disabled' ).removeClass( '-hint-visible' );
			}
		}
	}

	var modelFetchId = 0;

	// Per-brand model lists are bounded and slow-changing, so memoize them for the page's lifetime.
	// Re-selecting a brand (or toggling the vehicle-type tab, which the endpoint ignores) then
	// renders instantly without re-hitting REST/BFF. Keyed on the brand value the server varies on.
	var modelOptionsCache = {};

	/**
	 * Show or hide loading state on the model dropdown.
	 *
	 * @param {jQuery}  $form    Form element.
	 * @param {boolean} loading Whether models are being fetched.
	 */
	function setModelLoading( $form, loading ) {
		var $modelWrapper = $form.find( '.search-field.model' );
		var $modelSelect  = getModelSelect( $form );

		if ( ! $modelWrapper.length || ! $modelSelect.length ) {
			return;
		}

		$modelWrapper.toggleClass( '-loading', loading );

		if ( loading ) {
			$modelWrapper.attr( 'aria-busy', 'true' );
			$modelSelect.prop( 'disabled', true );
			$modelSelect.empty();
			$modelSelect.append(
				$( '<option>', {
					value: '',
					text: 'Model laden...',
				} )
			);
			return;
		}

		$modelWrapper.removeAttr( 'aria-busy' );
	}

	/**
	 * @param {jQuery} $form Form element.
	 * @param {Array}  modelOptions { value, label }[]
	 * @param {string} selectedValue Currently selected model.
	 */
	function updateModelSelect( $form, modelOptions, selectedValue ) {
		var $modelSelect = getModelSelect( $form );

		if ( ! $modelSelect.length ) {
			return;
		}

		var previousValue = selectedValue || $modelSelect.val();
		$modelSelect.empty();
		$modelSelect.append( $( '<option>', { value: '', text: 'Model' } ) );

		if ( ! modelOptions || ! modelOptions.length ) {
			return;
		}

		modelOptions.forEach( function( option ) {
			$modelSelect.append(
				$( '<option>', {
					value: option.value,
					text: option.label,
				} )
			);
		} );

		if ( previousValue ) {
			$modelSelect.find( 'option' ).each( function() {
				if ( this.value === previousValue ) {
					$modelSelect.val( previousValue );
				}
			} );
		}
	}

	/**
	 * Fetch model options from REST when merk or vehicle type tab changes.
	 *
	 * @param {jQuery} $form Form element.
	 */
	function fetchModelOptions( $form ) {
		var restUrl = getRestUrl( $form );

		if ( ! restUrl ) {
			return;
		}

		var merkValue = getMerkSelect( $form ).val();

		if ( ! merkValue || merkValue === '0' ) {
			setModelLoading( $form, false );
			updateModelSelect( $form, [], '' );
			updateModelFieldState( $form );
			return;
		}

		// Cache hit: render synchronously, skip the REST/BFF round-trip entirely.
		if ( Object.prototype.hasOwnProperty.call( modelOptionsCache, merkValue ) ) {
			// Invalidate any in-flight request so its later response can't overwrite this.
			modelFetchId++;
			setModelLoading( $form, false );
			updateModelSelect( $form, modelOptionsCache[ merkValue ], getModelSelect( $form ).val() );
			updateModelFieldState( $form );
			return;
		}

		var fetchId = ++modelFetchId;

		setModelLoading( $form, true );

		// The cached /aanbod/models endpoint only varies on the brand, so send just `merk`.
		$.get( restUrl, { merk: merkValue } )
			.done( function( response ) {
				if ( fetchId !== modelFetchId ) {
					return;
				}

				if ( ! response || ! response.success ) {
					updateModelSelect( $form, [], '' );
					return;
				}

				if ( response.selected_merk ) {
					modelOptionsCache[ response.selected_merk ] = response.model_options || [];
				}

				var currentMerk = getMerkSelect( $form ).val();
				var keepModel   = currentMerk === response.selected_merk ? getModelSelect( $form ).val() : '';

				updateModelSelect( $form, response.model_options || [], keepModel );
			} )
			.fail( function() {
				if ( fetchId !== modelFetchId ) {
					return;
				}

				updateModelSelect( $form, [], '' );
			} )
			.always( function() {
				if ( fetchId !== modelFetchId ) {
					return;
				}

				setModelLoading( $form, false );
				updateModelFieldState( $form );
			} );
	}

	function showModelHint( $element ) {
		var $wrapper = $element.closest( '.search-field.model' );

		if ( ! $wrapper.length ) {
			return;
		}

		$wrapper.addClass( '-hint-visible' );

		var existingTimeout = $wrapper.data( 'hint-timeout' );
		if ( existingTimeout ) {
			window.clearTimeout( existingTimeout );
		}

		const timeout = window.setTimeout( function() {
			$wrapper.removeClass( '-hint-visible' );
			$wrapper.removeData( 'hint-timeout' );
		}, 4000 );

		$wrapper.data( 'hint-timeout', timeout );
	}

	var disabledModelSelectSelector = formSelector + ' .search-field.model.-disabled select, ' + formSelector + ' .search-field.model.-disabled #header-filter-model';

	$( document ).on( 'change', formSelector + ' [name="merk"], ' + formSelector + ' #header-filter-merk', function() {
		var $form = $( this ).closest( formSelector );
		fetchModelOptions( $form );
	} );

	$( document ).on( 'change', formSelector + ' input[name="selectie_frontpage"]', function() {
		var $form = $( this ).closest( formSelector );
		fetchModelOptions( $form );
	} );

	$( document ).on( 'click', disabledModelSelectSelector, function() {
		showModelHint( $( this ) );
	} );

	$( document ).on( 'touchstart', disabledModelSelectSelector, function( e ) {
		e.preventDefault();
		showModelHint( $( this ) );
	} );

	$( document ).on( 'pointerdown', disabledModelSelectSelector, function( e ) {
		if ( e.pointerType === 'touch' ) {
			e.preventDefault();
			showModelHint( $( this ) );
		}
	} );

	$( document ).on( 'click', function( e ) {
		var $openWrappers = $( formSelector + ' .search-field.model.-hint-visible' );

		if ( ! $openWrappers.length ) {
			return;
		}

		$openWrappers.each( function() {
			var $wrapper = $( this );

			if ( ! $wrapper.is( e.target ) && $wrapper.has( e.target ).length === 0 ) {
				$wrapper.removeClass( '-hint-visible' );
				var existingTimeout = $wrapper.data( 'hint-timeout' );
				if ( existingTimeout ) {
					window.clearTimeout( existingTimeout );
					$wrapper.removeData( 'hint-timeout' );
				}
			}
		} );
	} );

	$( document ).on( 'submit', formSelector, function( e ) {
		e.preventDefault();
		window.location.href = buildArchiveUrl( $( this ) );
	} );

	$( function() {
		var $form = getForm();

		if ( ! $form.length ) {
			return;
		}

		updateModelFieldState( $form );

		if ( getMerkSelect( $form ).val() ) {
			fetchModelOptions( $form );
		}
	} );

} )( jQuery );
